import React from 'react';
import './loader.scss';

// const Loader = () => <img src="/assets/loader.svg" alt="loader" />;
const Loader = ({ shimmer }: any) => (
  <>
    {shimmer ? (
      <div className="card br">
        <div className="wrapper">
          <div className="profilePic animate din" />
          <div className="comment br animate w80" />
          <div className="comment br animate" />
          <div className="comment br animate" />
        </div>
      </div>
    ) : <img src="/assets/loader.svg" alt="loader" />}
  </>
);

export default Loader;
